module.exports = __webpack_public_path__ + "img/Ideen_Milo Health.ca43f981.png";